import React from 'react';
import styles from './Skeleton.module.css';

export default function Skeleton({ width = '100%', height = 16, variant = 'texto', className = '' }) {
    return (
        <span
            className={`${styles.skeleton} ${styles[variant] || styles.texto} ${className}`}
            style={{ width, height }}
            aria-hidden="true"
        />
    );
}
